import routerOptions0 from "/__w/gfh-corporate/gfh-corporate/nuxt/node_modules/.pnpm/nuxt@3.15.4_eslint@8.57.1_rollup@4.34.8_typescript@5.7.3_vite@6.2.0/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}